import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWithFolders from './AppWithFolders';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithFolders />
  </React.StrictMode>
);
